export const shimmer = (width: number, height: number) => `
        <svg width="${width}" height="${height}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <linearGradient id="g">
              <stop stop-color="#E5E5E5" offset="20%" />
              <stop stop-color="#FAFAFA" offset="50%" />
              <stop stop-color="#E5E5E5" offset="70%" />
            </linearGradient>
          </defs>
          <rect width="${width}" height="${height}" fill="#E5E5E5" />
          <rect id="r" width="${width}" height="${height}" fill="url(#g)" />
          <animate xlink:href="#r" attributeName="x" from="-${width}" to="${width}" dur="1s" repeatCount="indefinite"  />
        </svg>`;
